var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c656a984232d9d64e8a069a743d36687875f360a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hsd-website@biesse"]={id:"c656a984232d9d64e8a069a743d36687875f360a"};
      